import { useEffect, useState } from 'react'

import { MessageBox, Space, Tabs } from '../../../../../components/core-v2'
import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { actions as rawActions } from '../state/portfolio-slice'
import PortfolioDetailsSummaryStateless from './portfolio-details-summary-stateless'

const TradeEditPortfolioDetailsSummary = () => {
  const builderState = useAppSelector(state => state.builder)
  const portfolioState = useAppSelector(state => state.portfolio)
  const actions = useActions(rawActions)

  const [selectedTab, setSelectedTab] = useState<string>('pending')

  useEffect(() => {
    actions.init(builderState.note)
  }, [actions, builderState.note])

  const hasPendingState = portfolioState.readonlyPendingPortfolio !== undefined
  const onTabClick = (tabName: string) => {
    setSelectedTab(tabName)
  }

  return (
    <Space mx={5} my={6}>
      <Tabs.List>
        <Tabs.Tab
          isSelected={selectedTab === 'pending'}
          value="pending"
          onClick={() => onTabClick('pending')}
        >
          Incoming changes
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={selectedTab === 'current'}
          value="current"
          onClick={() => onTabClick('current')}
        >
          Current
        </Tabs.Tab>
      </Tabs.List>
      {selectedTab === 'pending' && (
        <Tabs.Panel value="pending">
          <>
            {hasPendingState && (
              <PortfolioDetailsSummaryStateless {...portfolioState.readonlyPendingPortfolio} />
            )}
            {!hasPendingState && (
              <Space my={6}>
                <MessageBox state="disabled">No changes have been made to the portfolio</MessageBox>
              </Space>
            )}
          </>
        </Tabs.Panel>
      )}
      {selectedTab === 'current' && (
        <Tabs.Panel value="current">
          <PortfolioDetailsSummaryStateless {...portfolioState.readonlyCurrentPortfolio} />
        </Tabs.Panel>
      )}
    </Space>
  )
}

export default TradeEditPortfolioDetailsSummary
